<script>
  import "./permissionless.css";
  import Sidebar from "./sidebar/Sidebar.svelte";
  import ProjectDetail from "./project-detail/ProjectDetail.svelte";
  import TokenDetails from "./token-details/TokenDetails.svelte";
  import SaleConfig from "./sale-config/SaleConfig.svelte";
  import SaleManager from "../../components/SaleManager.svelte";
  import { signerAddress } from "svelte-ethers-store";
  import ConnectWallet from "./ConnectWallet.svelte";
  import PreviewModal from "./permissionless-project-preview/preview-modal/PreviewModal.svelte";
  import { onMount, setContext } from "svelte";
  import {getPublicTiers} from '../../../services/projectDetailService'
  
  import {
    getBlockchains,
    getProjectVersions,
  } from "../../../services/projectDetailService";
  // import { blockchainAndVersion } from "../../../src/store";
  // import { get } from 'svelte/store'

  onMount(() => {
    window.scrollTo(0, 0);
  });
  import {
    createProject,
    updateProject,
    uploadImages,
  } from "../../../services/strapiRestService";

  import { projectDetailStore } from "../../stores/projectStore";
  import { projectSaleStore } from "../../stores/saleStore";
  import { tokenDetailStore } from "../../stores/tokenStore";

  import { getProjectDetailService } from "../../../services/projectDetailService";

  import { isLoaderActive } from "../../store";

  export let params = {};

  let step = 1;
  const setStep = (e) => {
    step = e.detail;
  };

  let modalStatus = false;
  const modalAction = () => {
    modalStatus = !modalStatus;
  };

  let blockchains;
  let projectVersion;

  Promise.allSettled([
    getBlockchains().then((value) => (blockchains = value)),
    getProjectVersions().then((value) => (projectVersion = value)),
  ]);

  let tokenDetail;
  tokenDetailStore.subscribe((value) => (tokenDetail = value));

  let projectDetail;
  projectDetailStore.subscribe((value) => (projectDetail = value));

  const fetchProjectDetails = async () => {
    isLoaderActive.set(true);
    let result = await getProjectDetailService(params.projectId);
    if(result.sale_address)
        return isLoaderActive.set(false);
        
    projectDetailStore.setProjectDetail({
      projectTitle: result.project_name,
      shortDescription: result.project_description,
      story: result.project_story,
      coverImage: result.project_cover,
      rewardDistributionDate: result.reward_distribution_date,
      rewards: result.rewards,
      mediaUrls: {
        facebook: result.facebook_url,
        instagram: result.instagram_url,
        twitch: result.twitch_url,
        twitter: result.twitter_url,
        youtube: result.youtube_url,
        linkedin: result.linked_in_url,
        discord: result.discord_url,
        telegram: result.telegram_url,
      },
    });

    tokenDetailStore.setProjectTokenDetail({
      tokenName: result.token_name,
      tokenSymbol: result.token_symbol,
      initialSupply: result.total_available_token,
      tokenDetails: result.token_details,
      projectTokenPrice: result.project_token_price,
    });

    projectSaleStore.setProjectSaleDetail({
      capPerWallet: result.individual_purchase_limit,
      recipient: result.recipient,
      reserveToken: result.reserve_token,
      coolDownDuration: result.cool_down_duration,
      forwardingAddress: result.forwarding_address,
      raiseTarget: result.project_raise_target,
      startDateAndTime: new Date(result.project_start_time).getTime(),
      endDateAndTime: new Date(result.project_end_time).getTime(),
    });

    isLoaderActive.set(false);
  };

  const generateData = async (fields, saleAddress, chainID) => {
    let data = {};
    let file;

    let {
      projectTitle,
      shortDescription,
      story,
      rewards,
      rewardDistributionDate,
      mediaUrls,
      coverImage,
    } = step == 1 ? fields : projectDetail;

    data = {
      project_name: projectTitle,
      project_description: shortDescription,
      project_story: story,
      rewards: rewards,
      reward_distribution_date: rewardDistributionDate,
      facebook_url: mediaUrls.facebook,
      instagram_url: mediaUrls.instagram,
      twitch_url: mediaUrls.twitch,
      twitter_url: mediaUrls.twitter,
      youtube_url: mediaUrls.youtube,
      linked_in_url: mediaUrls.linkedin,
      discord_url: mediaUrls.discord,
      telegram_url: mediaUrls.telegram,
    };

    file = coverImage;

    if (step > 1) {
      let {
        tokenName,
        tokenSymbol,
        initialSupply,
        tokenDetails,
        projectTokenPrice,
      } = step == 2 ? fields : tokenDetail;

      data = {
        ...data,
        token_name: tokenName,
        token_symbol: tokenSymbol,
        total_available_token: initialSupply,
        token_details: tokenDetails,
        project_token_price: projectTokenPrice,
      };

      if(step == 3){
        data = {
          ...data,
          individual_purchase_limit: fields.capPerWallet,
          recipient: fields.recipient,
          reserve_token: fields.reserveToken,
          cool_down_duration: fields.coolDownDuration,
          forwarding_address: fields.forwardingAddress,
          project_raise_target: fields.raiseTarget,
        }

        if (fields.startDateAndTime)
          data.project_start_time = new Date(
            fields.startDateAndTime
          ).toISOString();

        if (fields.endDateAndTime)
          data.project_end_time = new Date(fields.endDateAndTime).toISOString();
      }

    }

    if (projectDetail.rewardDistributionDate || fields.rewardDistributionDate) {
      data.reward_distribution_date =
        step == 1
          ? fields.rewardDistributionDate
          : projectDetail.rewardDistributionDate;
    }

    if (file instanceof File) {
      let image = await uploadImages(file);
      data.project_cover = image[0].id;
    } else if (!file) {
      data.project_cover = null;
    }

    data = {
      ...data,
      project_status: 'Upcoming',
      deployer: $signerAddress,
      raise_type: "Fixed_Raise",
      featured: false,
    }

    if (!saleAddress) data.publishedAt = null;
    else {
      let tierID = await getPublicTiers();
      if(tierID)
        data.wallet_tier = tierID;

      data.publishedAt = new Date().toISOString();
      data.sale_address = saleAddress;

      if(projectVersion)
        data.version = projectVersion;

      if(blockchains[chainID])
        data.chain = blockchains[chainID];
    }

    return data;
  };

  const create = async (fields, saleAddress, chainID) => {
    let result = await createProject(
      await generateData(fields, saleAddress, chainID)
    );
    params.projectId = result.data.id;
  };

  const update = async (fields, saleAddress, chainID) =>
    await updateProject(
      params.projectId,
      await generateData(fields, saleAddress, chainID)
    );

  const saveProject = async (fields, saleAddress, chainID) => {
    return params.projectId
      ? update(fields, saleAddress, chainID)
      : create(fields, saleAddress, chainID);
  };

  setContext("save-project", saveProject);

  const resetForm = () => {
    projectDetailStore.reset();
    tokenDetailStore.reset();
    projectSaleStore.reset();
  };

  if (params.projectId) fetchProjectDetails();
  else resetForm();
</script>

{#if $signerAddress}
  <div id="permissionless" class="permissionless-wrapper flex flex-wrap">
    <div class="container">
      <div class="permissionless-content-wrapper flex items-start">
        <div class="pl-sidebar-wrap flex flex-wrap column-direction">
          <Sidebar sidebarStep={step} on:next={setStep} />
        </div>
        {#if !$isLoaderActive || !params.projectId}
          <SaleManager>
            <div class="pl-content-wrapper">
              {#if step === 1}
                <ProjectDetail on:next={() => (step = 2)} />
              {:else if step === 2}
                <TokenDetails
                  on:next={() => (step = 3)}
                  on:back={() => (step = 1)}
                />
              {:else if step === 3}
                <SaleConfig
                  on:modalAction={modalAction}
                  on:next={() => (step = 4)}
                  on:back={() => (step = 2)}
                />
              {/if}
            </div>
          </SaleManager>
        {/if}
        <PreviewModal {modalStatus} on:modalAction={modalAction} />
        <!--        <TermsModal {termsModalStatus} on:onTermsAccepted={createTermsModal} />-->
      </div>
    </div>
  </div>
{:else}
  <ConnectWallet />
{/if}
